import React, {useContext, useEffect, useState} from "react";
import {Link} from "react-router-dom";
import cn from "classnames";
import OutsideClickHandler from "react-outside-click-handler";
import styles from "./User.module.sass";
import Icon from "../../Icon";
import Theme from "../../Theme";
import config from "../../../config";
import {get} from "../../../adapters/api";
import Balance from "../../Balance";
import CopyButton from "../../CopyButton";
import ShortenAddress from "../../ShortenAddress";
import {Web3Context} from "../../../contexts/Web3Context";

const items = [
    {
        title: "My profile",
        icon: "user",
        url: "/profile",
    },
    // {
    //     title: "My items",
    //     icon: "image",
    //     url: "/my-items",
    // },
];

const User = ({className}) => {
    const [visible, setVisible] = useState(false);
    const [user, setUser] = useState(false);

    const {isConnected, defaultAccount, defaultAccountBalance} = useContext(Web3Context);

    useEffect(() => {
        (async () => {
            if (defaultAccount && !user) {
                try {
                    const userInfo = await get('user/profile?from=' + defaultAccount);
                    setUser(userInfo.data);
                } catch (e) {
                }
            }
        })();
    }, [defaultAccount, user]);

    return (
        <OutsideClickHandler onOutsideClick={() => setVisible(false)}>
            <div className={cn(styles.user, className)}>
                <div className={styles.head} onClick={() => setVisible(!visible)}>
                  {isConnected &&
                    <div className={styles.avatar}>
                      <img
                        src={(user && user.avatar) || '/images/content/avatar-user.jpg'}
                        alt="Avatar"/>
                    </div>
                  }

                    <div className={styles.wallet}>
                        <Balance/>
                    </div>
                </div>
                {visible && (
                    <div className={styles.body}>
                        <div className={styles.name}>{(user && user.username) || 'NoName'}</div>
                        <div className={styles.code}>
                            {user && (
                                <>
                                {<ShortenAddress address={user.address}/> || '0x'}
                                    <CopyButton text={user.address}/>
                                </>
                            )}
                        </div>
                        <div className={styles.wrap}>
                            <div className={styles.line}>
                                <div className={styles.preview}>
                                    <img
                                        src="/images/content/gnosis-logo.png"
                                        alt={config.networkName}
                                    />
                                </div>
                                <div className={styles.details}>
                                    <div className={styles.info}>Balance</div>
                                    <div className={styles.price}><Balance amount={defaultAccountBalance}/></div>
                                </div>
                            </div>
                        </div>
                        <div className={styles.menu}>
                            {items.map((x, index) =>
                                x.url ? (
                                    x.url.startsWith("http") ? (
                                        <a
                                            className={styles.item}
                                            href={x.url}
                                            rel="noopener noreferrer"
                                            key={index}
                                        >
                                            <div className={styles.icon}>
                                                <Icon name={x.icon} size="20"/>
                                            </div>
                                            <div className={styles.text}>{x.title}</div>
                                        </a>
                                    ) : (
                                        <Link
                                            className={styles.item}
                                            to={x.url}
                                            onClick={() => {window.location.href=x.url}}
                                            key={index}
                                            target="_self"
                                        >
                                            <div className={styles.icon}>
                                                <Icon name={x.icon} size="20"/>
                                            </div>
                                            <div className={styles.text}>{x.title}</div>
                                        </Link>
                                    )
                                ) : (
                                    <div className={styles.item} key={index}>
                                        <div className={styles.icon}>
                                            <Icon name={x.icon} size="20"/>
                                        </div>
                                        <div className={styles.text}>{x.title}</div>
                                        <Theme className={styles.theme}/>
                                    </div>
                                )
                            )}
                        </div>
                    </div>
                )}
            </div>
        </OutsideClickHandler>
    );
};

export default User;
